import { useQuery } from "@tanstack/react-query";
import { usDateFormate } from "../../../hooks/dateFormat";
import apiTaskboardLeave from "../../../services/leave/apiTaskboardLeave";

export default function TaskboardLeaveQuery(
  startDate,
  endDate,
  currentEmployeeId
) {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["taskboardleave", startDate, endDate, currentEmployeeId],
    queryFn: () =>
      apiTaskboardLeave(startDate, endDate, currentEmployeeId),
  });

  const report = data?.data.taskboard_leave_list?.map((item) => ({
    id: item.application_id,
    col1: item.employee_name,
    col2: usDateFormate(item.date),
    col3: item.status,
    col4: item.application_id,
  }));

  return { report, isLoading, refetch };
}
